import { IModel, Model } from './Model';
import { DateTime } from 'luxon';
import { defaultTo } from 'lodash';
import { FollowUpTypeModel } from './FollowUpTypeModel';

export interface IVisitNoteModel extends IModel {
  visitNoteId: number;
  visitId: number;
  followUpTypeId: number;
  notes: string;
  isPrivateNote: boolean;
  followUpType: undefined; // FollowUpTypeModel
  noteDate: string;
  createdUserTitle: string;
  createdUserFirstName: string;
  createdUserLastName: string;
  visitNoteTypeId: number | undefined;
}

export class VisitNoteModel
  extends Model
  implements Record<keyof IVisitNoteModel, any>
{
  visitNoteId: number;
  visitId: number;
  followUpTypeId: number;
  notes: string;
  isPrivateNote: boolean;
  followUpType: FollowUpTypeModel | undefined;
  noteDate: DateTime | undefined;
  createdUserTitle: string;
  createdUserFirstName: string;
  createdUserLastName: string;
  visitNoteTypeId: number | undefined;

  constructor(params: Partial<IVisitNoteModel>) {
    super(params);
    this.visitNoteId = defaultTo(params.visitNoteId, 0);
    this.visitId = defaultTo(params.visitId, 0);
    this.visitNoteTypeId = params.visitNoteTypeId;
    this.followUpTypeId = defaultTo(params.followUpTypeId, 1); // default to NoFollowup
    this.followUpType = params.followUpType
      ? new FollowUpTypeModel(params.followUpType)
      : FollowUpTypeModel.defaultFollowUpType; // default to NoFollowup
    this.notes = defaultTo(params.notes, '');
    this.isPrivateNote = params.isPrivateNote ?? false;
    this.noteDate = params.noteDate
      ? DateTime.fromISO(params.noteDate, { zone: 'utc' })
      : undefined;
    this.createdUserTitle = defaultTo(params.createdUserTitle, '');
    this.createdUserFirstName = defaultTo(params.createdUserFirstName, '');
    this.createdUserLastName = defaultTo(params.createdUserLastName, '');
  }

  static fromVisit(visitId: number, visitNoteTypeId: number | undefined) {
    return new VisitNoteModel({
      visitId: visitId,
      visitNoteTypeId: visitNoteTypeId,
    });
  }
}
